export enum AuthRoutes {
  UNAUTHORIZED = '/error/401',
  NOT_FOUND = '/error/404',
  ERROR = '/error/500'
}
